import fetch from 'utils/fetch';

export const update = (id, json) => {
  return fetch(`/pco-manager/aast/cases/${id}/transfer `, {
    // TODO change to transfer controller
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(json, (key, value) => {
      return value === '' ? undefined : value;
    }),
  });
};



// WEBPACK FOOTER //
// ./src/modules/saas/aast/common/modals/case-transfer/api/index.js